<template>
  <div>
    <!-- Date range filter -->
    <div class="row my-3">
      <div class="col">
        <vc-date-picker
          v-model="range"
          :model-config="modelConfig"
          is-range
        >
          <template #default="{ inputValue, inputEvents }">
            <div class="flex justify-center items-center">
              <input
                :value="inputValue.start"
                class="border px-1 pb-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                v-on="inputEvents.start"
              >
              -
              <input
                :value="inputValue.end"
                class="border px-1 pb-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                v-on="inputEvents.end"
              >

              <button
                class="btn btn-primary btn-sm"
                :disabled="loadingRequests"
                @click="handleFilter"
              >
                Filter
              </button>
              <div
                v-if="loadingRequests"
                class="spinner-grow text-primary"
                role="status"
              >
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </template>
        </vc-date-picker>
      </div>
    </div>
    <!-- eof Date range filter -->

    <!-- Other Staff Table -->
    <requested-staff-table
      :requested-staffs="otherStaffs"
      :loading-requests="loadingRequests"
      :date-range="range"
      :show-url="false"
    />
  </div>
</template>

<script>
import RequestedStaffTable from "./RequestedStaffTable.vue";
import { mapGetters, mapActions } from "vuex";
import moment from "moment-timezone";

export default {
  name: "OtherStaffCreditTable",
  components: {
    RequestedStaffTable,
  },
  props: {
    staffId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loadingRequests: false,
      range: {
        start: moment().startOf("month").format("YYYY-MM-DD"),
        end: moment().endOf("month").format("YYYY-MM-DD"),
      },
      modelConfig: {
        end: {
          timeAdjust: "23:59:59",
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      otherStaffs: "credit/otherStaffList",
    }),
  },
  mounted() {
    this.fetchOtherStaffs({
      staffId: this.staffId,
      startDate: this.range.start,
      endDate: this.range.end,
    });
  },
  methods: {
    async fetchOtherStaffs({ staffId, startDate, endDate }) {
      try {
        this.loadingRequests = true;
        await this.getOtherStaffList({
          staffId: staffId,
          startDate: startDate,
          endDate: endDate,
        });
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingRequests = false;
      }
    },
    handleFilter() {
      this.fetchOtherStaffs({
        staffId: this.staffId,
        startDate: this.range.start,
        endDate: this.range.end,
      });
    },
    ...mapActions({
      getOtherStaffList: "credit/getOtherStaffList",
    }),
  },
};
</script>

<style scoped></style>
